import { globalGetService } from "../../../globalServices";
import checkApiStatus, { getLocalStorageInfo } from "../../../utils";

export function getAccountTypeApi() {
    globalGetService(`console/get-constants/?constant_type=reserve_account_type`)
        .then(response => {
            if (response.data.statusCode === 200) {
                let info = getLocalStorageInfo()
                if(info.defaultLessor.id == 442 || info.defaultLessor.id == 463){
                    
                    this.setState({
                        accType: response.data.data
                    })
                }
                else{
                    this.setState({
                        accType: response.data.data.filter(i=> i.value !== 4)
                    })
                }
            }
        })
}
export function getRentalAccountTypeApi() {
    globalGetService(`console/get-constants/?constant_type=rental_account_type`)
        .then(response => {
            if (response.data.statusCode === 200) {
                let info = getLocalStorageInfo()
                if(info.defaultLessor.id == 442 || info.defaultLessor.id == 463){
                    
                    this.setState({
                        accType: response.data.data
                    })
                }
                else{
                    this.setState({
                        accType: response.data.data.filter(i=> i.value !== 4)
                    })
                }
            }
        })
}
export function getEngineThurstApi (enignetype) {
        globalGetService(`console/engine-types/`,{engine_family_engine_type:enignetype, for_thrust:true})
            .then(response => {
                if (checkApiStatus(response)) {
                    let filteredResp = response.data.data?.engineTypes.map(item=> ({engine_thrust_name:item?.engine_thrust_name , id: item?.id, name:item?.name, engine_thrust_id: item?.engine_thrust_id}))
                    this.setState({engineTypes:filteredResp})
                }
            })
}

export function getModuleDescriptionApi(params, query,type,editData) {
    this.setState({ tableLoader: true });
    globalGetService(`console/v2/asset/engine/${params}/llp/`, { for_reserve_account: query })
        .then(response => {
            if (checkApiStatus(response)) {
                this.setState({ tableLoader: false });
                if (query === "module") {
                    const updatedModuleResponse = response?.data?.data?.map(ele => {
                        return { module_name: ele }
                    })
                    if(type === "add"){
                        this.setState(prevState => ({
                            ...prevState,
                            mrRate: {
                                ...prevState.mrRate,
                                engine_split_details: updatedModuleResponse,
                            }
                        }))
                    }else{
                        const existingNames = new Set(editData.map(mod => mod.module_name));

                        const newModules = updatedModuleResponse
                            .filter(mod => !existingNames.has(mod.module_name))
                            .map(mod => ({
                                module_name: mod.module_name,
                                description: null,
                                fund_allocation_percentage: 0,
                                starting_fund: 0,
                                balance_as_of_date: null,
                            }));

                        const finalModules = [...editData, ...newModules];
                        this.setState(prevState => ({
                            ...prevState,
                            mrRate: {
                                ...prevState.mrRate,
                                engine_split_details: finalModules,
                            },
                        }))
                    }
                } 
                else {
                    const seen = {};
                    const cleanedData = {};
                    let data = response?.data?.data
                    Object.keys(response?.data?.data).forEach(module => {
                        const uniqueParts = [];
                        data[module].forEach(part => {
                            if (!seen[part]) {
                                seen[part] = true;
                                uniqueParts.push(part);
                            }
                        });
                        cleanedData[module] = uniqueParts;
                    });
                    const fundData = Object.entries(cleanedData).map(([module, descriptions]) => ({
                        module,
                        descriptions
                      }));
                      const flatData = fundData?.flatMap(item =>
                        item.descriptions.map(description => ({
                        module_name: item.module,
                          description
                        }))
                      );
                     if(type === "add"){
                        this.setState(prevState => ({
                            ...prevState,
                            mrRate: {
                                ...prevState.mrRate,
                                engine_split_details: flatData
                            }
                        }))
                     }else{
                         const updatedEditData = [...editData];
                         const existingPairs = new Set(editData.map(d => `${d.module_name}||${d.description}`));
                         flatData.forEach(({ module_name, description }) => {
                             const key = `${module_name}||${description}`;
                             if (!existingPairs.has(key)) {
                                 updatedEditData.push({
                                     module_name,
                                     description,
                                     fund_allocation_percentage: 0,
                                     starting_fund: 0,
                                     balance_as_of_date: null,
                                 });
                                 existingPairs.add(key);
                             }
                         });

                         this.setState(prevState => ({
                             ...prevState,
                             mrRate: {
                                 ...prevState.mrRate,
                                 engine_split_details: updatedEditData
                             }
                         }))
                     }
                     
                }

            }
        })
}
